import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { IMusimapQueryParams } from '../musimap-common/musimap-common.interface';
import { MUSIMAP_DIVISIONS } from '../musimap-common/musimap-common.enum';

export interface IMusimapQueryParamsState extends EntityState<IMusimapQueryParams> {
  isReady: boolean;
  params: IMusimapQueryParams;
}

@Injectable()
@StoreConfig({ name: 'musimap-filters' })
export class MusimapFiltersStorage extends EntityStore<IMusimapQueryParamsState, IMusimapQueryParams> {
  public static getDefaultState = () => ({
    isReady: false,
    params: {
      includeFilters: [],
      excludeFilters: [],
      rangeSearchFilter: [],
      divisions: [],
    },
  });

  public static getDefaultDivisionSelections = () => ({
    [MUSIMAP_DIVISIONS.WCM]: [MUSIMAP_DIVISIONS.WMG, MUSIMAP_DIVISIONS.NON_WMG, MUSIMAP_DIVISIONS.WCM],
    [MUSIMAP_DIVISIONS.WMG]: [MUSIMAP_DIVISIONS.WCM, MUSIMAP_DIVISIONS.NON_WCM, MUSIMAP_DIVISIONS.WMG],
    [MUSIMAP_DIVISIONS.WMG_WCM]: [
      MUSIMAP_DIVISIONS.WMG,
      MUSIMAP_DIVISIONS.NON_WMG,
      MUSIMAP_DIVISIONS.WCM,
      MUSIMAP_DIVISIONS.NON_WCM,
    ],
  });

  constructor() {
    super(MusimapFiltersStorage.getDefaultState());
  }
}
